import React from "react";
/** composants **/
import { Navbar } from '../Navbar';
import Footer from '../components/Footer';
import FaqMariage from '../components/CinqQuestionsMariage';
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
//img & icon
import { CheckIcon } from "@heroicons/react/20/solid";
import { ArrowRightIcon, ChatBubbleBottomCenterIcon, CurrencyEuroIcon, DocumentCheckIcon, ScaleIcon } from "@heroicons/react/24/solid";
import BackHeaderTop from "../components/BackHeaderTop";
import BackHeaderBottom from "../components/BackHeaderBottom";
import GoogleAvis2 from '../img/google-avis-2.png';
import MariageImg from '../img/mariage-lead.webp';
import AccompagnementClotere from '../components/AccompagnementClotere';
import Testimonials from "../components/Testimonials";


function Mariage2(args) {

    const startChat = () => {
            if (window.Intercom) {
              // Affiche le widget
              window.Intercom('show');
        
              // Lance une nouvelle conversation
              window.Intercom('startConversation');
            }
    };
    return (
        <>
            <Helmet>
                <title>Contrat de mariage notaire en ligne – Simple & rapide avec Clotere</title>
                <meta name="robots" content="index,follow" />
                <meta name="googlebot" content="index,follow" />
                <meta name='description' content='Préparez votre contrat de mariage avec un notaire. Clotere vous accompagne en ligne, en toute simplicité. À partir de 369€.' />
                <meta property="og:url" content="https://clotere.fr/notaire-contrat-mariage" />
                <meta property="og:site_name" content="Clotere" />
                <meta property="og:image" content="https://clotere.fr/facebook-share-webp" />
                <meta property="og:type" content="website" />
            </Helmet>


            {/**header 2 */}
            <div className="relative rounded-4xl ">
                <BackHeaderTop />
                <Navbar user={args.user} />

                <div className="relative container ">

                    <header class="flex flex-row flex-wrap justify-center sm:py-10 items-center">
                        <div className="w-full  p-3 sm:p-4 flex flex-col sm:gap-6 text-center">
                            
                            {/**bloc avis */}
                            <div>
                                <div className="flex gap-2 items-center  justify-center">
                                    <img src={GoogleAvis2} className="w-32" alt="Notaire en ligne pour contrat de mariage avec Clotere" />
                                    <p className="m-0 text-sm font-bold">5 | <a target="blank" href="https://www.google.com/search?sca_esv=d214253f9e079b85&hl=fr&authuser=0&q=Clotere&si=APYL9bs7Hg2KMLB-4tSoTdxuOx8BdRvHbByC_AuVpNyh0x2KzZDzCaQ6PPw1Mgvvzif6RPDbzlyvfgpBpItJUodOtpKTPaOfRqxPnJiVlFGA37fDf9TtdoQ%3D&uds=ABqPDvysoTTq_vp6PiQY3u-nn8x5mrrThE-WixzhGgTgcP_mlCE3-A4gQLqOtz9y4LiiTIbfFBKkE3gMtki_Kkb4BD_mskaVaRvCLgFEWxykHDgiwrX4QIM&sa=X&ved=2ahUKEwjSoubx5s2MAxUaTqQEHXPXOdUQ3PALegQIGhAE&biw=1511&bih=765&dpr=2" className="text-black !font-normal">8 avis</a></p>
                                </div>
                            </div>
                            <h1 className="font-medium text-transparent sm:!text-[60px] tracking-[0]  mb-0" >
                                <span className=" text-black">Préparez votre   <span className="font-bold mt-2 text-indigo-800">contrat de mariage</span> avec un notaire fiable et rapide.</span>
                            </h1>
                            
                            
                            {/** step 1,2,3 */}
                            <div className="mx-auto mt-16 max-w-2xl lg:max-w-none">
                                <dl className="grid max-w-xl grid-cols-1 gap-x-8 gap-y-16 lg:max-w-none lg:grid-cols-3 justify-center">
                                    <div className="flex flex-row gap-3">
                                        <dt className="text-[30px] font-semibold leading-7 text-gray-900">
                                            <div className="flex h-16 w-16 items-center justify-center  rounded-full bg-indigo-500 text-white">
                                                1
                                            </div>

                                        </dt>
                                        <dd className="flex flex-auto flex-col text-base leading-7 text-gray-800 text-left">

                                            <p className="flex-auto font-bold  text-[20px] mb-0">Fixez gratuitement un rendez-vous avec votre notaire </p>

                                        </dd>
                                    </div>
                                    <div className="flex flex-row gap-8 items-center">
                                        <dt className="text-[30px] font-semibold leading-7 text-gray-900">
                                            <div className="flex  h-16 w-16 items-center justify-center  rounded-full bg-indigo-500 text-white">
                                                2
                                            </div>

                                        </dt>
                                        <dd className="flex flex-auto flex-col text-base leading-7 text-gray-800 text-left">

                                            <p className="flex-auto font-bold  text-[20px] mb-0">Choisissez votre régime matrimonial </p>

                                        </dd>
                                    </div>
                                    <div className="flex flex-row gap-8">
                                        <dt className="text-[30px] font-semibold leading-7 text-gray-900">
                                            <div className="flex  h-16 w-16 items-center justify-center  rounded-full bg-indigo-500  text-white">
                                                3
                                            </div>

                                        </dt>
                                        <dd className="flex flex-auto flex-col text-base leading-7 text-gray-800 text-left">

                                            <p className="flex-auto font-bold  text-[20px]  mb-0">Signez votre contrat de mariage </p>

                                        </dd>
                                    </div>

                                </dl>
                            </div>

                            {/** bloc bouton */}
                            <div>
                                
                                <div className="flex flex- flex-wrap gap-3 justify-center items-center">
                                <Link onClick={startChat}
                                                                    type="button"
                                                                    className=" box-content mt-3 no-underline inline-flex items-center gap-x-2 rounded-md bg-indigo-200 px-3.5 py-3.5 text-lg font-semibold text-indigo-800 shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                                                >
                                                                    Poser une question à un notaire
                                                                </Link>
                                <Link to="/onboard/mariage"
                                    type="button"
                                    className=" box-content mt-3 no-underline inline-flex items-center gap-x-2 rounded-md bg-indigo-600 px-3.5 py-3.5 text-lg font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                >
                                    Débuter mon contrat de mariage
                                    <ArrowRightIcon aria-hidden="true" className="-mr-0.5 size-5" />
                                </Link>
                                
                                </div>
                                <div className="flex flex-row gap-4 items-center mt-2 justify-center">
                                    <div className="flex flex-row gap-1 items-center text-xs">
                                        <CheckIcon className="size-4 flex" />
                                        5 minutes
                                    </div>
                                    <div className="flex flex-row gap-1 items-center text-xs">
                                        <CheckIcon className="size-4" />
                                        1er rdv gratuit
                                    </div>
                                </div>
                                
                            </div>

                            
                        </div>
                        <div className="flex flex-col sm:flex-row gap-16 mt-20 items-center ">
                        <div className=" w-full sm:w-1/2  p-0 lg:p-5  sm:flex justify-center overflow-hidden rounded-2xl">
                            <img className="object-cover" src={MariageImg} alt="Vos démarches chez le notaire pour votre contrat de mariage" />
                        </div>
                        <div className=" w-full sm:w-1/2  p-0 lg:p-5  sm:flex justify-center overflow-hidden">
                            {/** bloc ccm */}
                
                        
                            <dl className="flex flex-col gap-x-8 gap-y-4  lg:max-w-none lg:grid-cols-4 justify-center">
                                <div className="flex flex-row sm:flex-col gap-3">
                                    <dt className="text-[30px] font-semibold leading-7 text-gray-900">
                                        <div className="flex h-10 w-10 items-center justify-center  rounded-full bg-indigo-500">
                                            <ChatBubbleBottomCenterIcon className="h-4 w-4 text-white" />
                                        </div>

                                    </dt>
                                    <dd className="flex flex-auto flex-col text-base leading-7 text-gray-600">
                                        <p className=" text-[20px] font-bold mb-0">Parlez avec votre notaire gratuitement</p>
                                        <p className=" text-base mb-0">Discutez avec votre notaire du meilleur régime matrimonial pour votre couple</p>

                                    </dd>
                                </div>
                                <div className="flex flex-row sm:flex-col gap-3">
                                    <dt className="text-[30px] font-semibold leading-7 text-gray-900">
                                        <div className="flex h-10 w-10 items-center justify-center  rounded-full bg-indigo-500">
                                            <CurrencyEuroIcon className="h-4 w-4 text-white" />
                                        </div>

                                    </dt>
                                    <dd className="flex flex-auto flex-col text-base leading-7 text-gray-600">
                                        <p className=" text-[20px] font-bold mb-0">Un prix fixe sans surprise</p>
                                        <p className=" text-base mb-0">Le tarif d'un contrat de mariage est défini par le notaire selon votre situation. À partir de 369 € </p>

                                    </dd>
                                </div>
                                <div className="flex flex-row sm:flex-col gap-3">
                                    <dt className="text-[30px] font-semibold leading-7 text-gray-900">
                                        <div className="flex h-10 w-10 items-center justify-center  rounded-full bg-indigo-500">
                                            <DocumentCheckIcon className="h-4 w-4 text-white" />
                                        </div>

                                    </dt>
                                    <dd className="flex flex-auto flex-col text-base leading-7 text-gray-600">
                                        <p className=" text-[20px] font-bold mb-0">Constituez votre dossier en ligne</p>
                                        <p className=" text-base mb-0">Ajoutez vos documents et infos depuis votre espace client Clotere.</p>

                                    </dd>
                                </div>
                                <div className="flex flex-row sm:flex-col gap-3">
                                    <dt className="text-[30px] font-semibold leading-7 text-gray-900">
                                        <div className="flex h-10 w-10 items-center justify-center  rounded-full bg-indigo-500">
                                            <ScaleIcon className="h-4 w-4 text-white" />
                                        </div>

                                    </dt>
                                    <dd className="flex flex-auto flex-col text-base leading-7 text-gray-600">
                                        <p className=" text-[20px] font-bold mb-0">Signez quand vous êtes prêts</p>
                                        <p className=" text-base mb-0">Choisissez une date et signez en ligne ou en présentiel.</p>

                                    </dd>
                                </div>
                            </dl>
                        </div>
                        </div>
                        
                    </header>
                </div>
                <BackHeaderBottom />
                <AccompagnementClotere />
            </div>
            <FaqMariage />
            <Testimonials/>
            <Footer />
        </>
    );
}

export default Mariage2;